// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/tenants/ticket-types/ui/LangTabsBlock/styles.scss
// module id = 282
// module chunks = 62